<script setup>
import { reactive, computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

import NextInput from '@/components/Form/NextInput.vue'
import Button from '@/components/Button.vue'
import { useAlert } from '@/composables/useToast'

const emit = defineEmits(['close'])

const store = useStore()
const { t } = useI18n()

const form = reactive({
  name: '',
  website_url: '',
})

const rules = computed(() => ({
  website_url: { required },
}))

const v$ = useVuelidate(rules, form)

const uiFlags = computed(() => store.getters['inboxes/getUIFlags'])

const submit = async () => {
  v$.value.$touch()
  if (v$.value.$invalid) return
  try {
    await store.dispatch('inboxes/createWebWidget', { ...form })
    useAlert(t('INBOX_MGMT.ADD.WEB_WIDGET.API.SUCCESS'))
    emit('close')
  } catch (error) {
    useAlert(t('INBOX_MGMT.ADD.WEB_WIDGET.API.ERROR_MESSAGE'))
  }
}
</script>

<template>
  <form class="flex flex-col gap-5" @submit.prevent="submit">
    <p class="text-body-main text-n-slate-11">
      {{ $t('INBOX_MGMT.ADD.WEB_WIDGET.HELP') }}
    </p>

    <NextInput
      v-model="form.website_url"
      name="widget_website_url"
      type="text"
      required
      :label="$t('INBOX_MGMT.ADD.WEB_WIDGET.URL.LABEL')"
      :placeholder="$t('INBOX_MGMT.ADD.WEB_WIDGET.URL.PLACEHOLDER')"
      :has-error="v$.website_url.$error"
      @input="v$.website_url.$touch"
    />

    <NextInput
      v-model="form.name"
      name="widget_inbox_name"
      type="text"
      :label="$t('INBOX_MGMT.ADD.WEB_WIDGET.NAME.LABEL')"
      :placeholder="$t('INBOX_MGMT.ADD.WEB_WIDGET.NAME.PLACEHOLDER')"
    />

    <div class="flex justify-end gap-2 pt-2">
      <Button
        faded
        slate
        type="button"
        :label="$t('INBOX_MGMT.ADD.CANCEL')"
        @click="emit('close')"
      />
      <Button
        type="submit"
        :label="$t('INBOX_MGMT.ADD.SUBMIT')"
        :disabled="uiFlags.isCreating"
      />
    </div>
  </form>
</template>
